import { Stack, Typography } from "@mui/material";

/**
 * Standard page title block: heading, optional subtitle, and a slot on the
 * right for the page's primary action(s).
 */
export default function PageHeader({ title, subtitle, action }) {
    return (
        <Stack
            sx={{
                flexDirection: { xs: "column", sm: "row" },
                alignItems: { xs: "flex-start", sm: "center" },
                justifyContent: "space-between",
                gap: 2,
                mb: 3,
            }}
        >
            <Stack sx={{ gap: 0.5 }}>
                <Typography variant="h5">{title}</Typography>
                {subtitle && (
                    <Typography
                        variant="body2"
                        sx={{ color: "var(--text-secondary)" }}
                    >
                        {subtitle}
                    </Typography>
                )}
            </Stack>

            {action}
        </Stack>
    );
}
